import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Button, Col, Divider, Dropdown, Flex, Grid, Layout, Menu, Row, Space } from "antd";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/app";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { doLogout, setSessionTimeOut } from "../../../store/AuthSlice";
import { WebConstant } from "../../webPages/webConstant/WebConstant";
import type { MenuProps } from 'antd';

import CommonModal from "../../../components/Modals/CommonModal";
import SVGIcon from "../../../utils/SVGIcon";
import ProfileArrowIcon from "../../../assets/images/icon/profile-arrow-icon.svg?react";
import { FundProjectionScreenOutlined, ThunderboltOutlined } from "@ant-design/icons";
import { CONSTANT } from "../../../config/Constant";
import DashboardTranslateButtons from "../../../components/GoogleTranslateElement/DashboardTranslateButtons";

// import { icon } from "@fortawesome/fontawesome-svg-core";

interface SidebarViewProps {
    collapsed: boolean;
    SetCollapsed: Dispatch<SetStateAction<boolean>>;
}

/**
 * Renders the header view component for the main layout containing login and dropdown.
 *
 * @return {ReactElement} The rendered header view component.
 */
const SidebarView: React.FC<SidebarViewProps> = ({ collapsed, SetCollapsed }) => {
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const userDetail = useSelector((state: RootState) => state.AUTH.userDetail)
    const logo = useSelector((state: RootState) => state.HOME.pageSettings?.banner?.banner_logo)
    const [logOutModal, setLogOutModal] = useState(false)
    const [isMobile, setIsMobile] = useState(false)
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();


    const location = useLocation()



    // call logout function
    const showModal = () => {
        setLogOutModal(true)
    };
    const closeModal = () => {
        setLogOutModal(false)
    }
    const logOut = () => {
        sessionStorage.removeItem("welcomeData");
        dispatch(doLogout()).then(() => {
            dispatch(setSessionTimeOut(false))
            setLogOutModal(false)
            navigate("/login");
        });
    }


    const siderStyle: React.CSSProperties = {
        overflow: 'auto',
        height: ((screens.sm && !screens.md) || screens.xs) ? '92dvh' : '100dvh',
        position: 'sticky',
        insetInlineStart: 0,
        top: 0,
        bottom: 0,
        scrollbarWidth: 'thin',
        scrollbarGutter: 'stable',
        maxWidth: 'auto',
        zIndex: '4'
    };


    const items2 = [
        {
            label: <Link title="Career Discovery Journey" to={'/dashboard'}>Career Discovery Journey</Link>,
            link: "/dashboard",
            key: "/dashboard",
            icon: <SVGIcon icon="CareerDiscoveryIcon" />,
            style: { paddingLeft: 'auto' },
            title: "Career Discovery Journey"
        },
        {
            label: <Link title="Energy Careers Index" to={'/careers'}>Energy Careers Index</Link>,
            link: "/careers",
            key: "/careers",
            icon: <SVGIcon icon="EnergyCarrersIcon" />,
            style: { paddingLeft: 'auto' },
            title: "Energy Careers Index"


        },
        {
            label: <Link title="Saved Careers" to={'/saved-careers'}>Saved Careers</Link>,
            link: "/saved-careers",
            key: "/saved-careers",
            icon: <SVGIcon icon="SavedCareersIcon" />,
            style: { paddingLeft: 'auto' },
            title: "Saved Careers"


        },
        {
            label: <Link title="Industry Awareness Hub" to={'/energy-industries'}>Industry Awareness Hub</Link>,
            link: "/energy-industries",
            key: "/energy-industries",
            icon: <ThunderboltOutlined style={{color:'#95979d'}} />,
            style: { paddingLeft: 'auto' },
            title: "Industry Awareness Hub"

        },
        {
            label: <Link title="Training and Pathways" to={CONSTANT.THINKIFIC_URL} target="_blank">Training and Pathways</Link>,
            link: CONSTANT.THINKIFIC_URL,
            key: "training-and-pathways",
            icon: <FundProjectionScreenOutlined  style={{color:'#95979d'}}/>,
            style: { paddingLeft: 'auto' },
            title: "Training and Pathways"


        },
        {
            label: <div>Resources</div>,
            key: "Resources",
            icon: <SVGIcon icon="ResourcesIcon" width={20} />,
            style: { paddingLeft: 'auto' },
            // extra:extraIcon
            children: [
                // {
                //     key: '/resources',
                //     label: <Link to={'/resources'}>Exploration</Link>,
                // },
                {
                    key: '/acronyms',
                    label: <Link title="Energy Glossary" to={'/acronyms'} >Energy Glossary</Link>,
                    title: "Energy Glossary"
                },
                {
                    key: '/locations',
                    label: <Link title="Training Locations" to={'/locations'} >Training Locations</Link>,
                    title: "Training Locations"
                },
                // {
                //     key: '/training-credentials',
                //     label: <Link to={'/training-credentials'} >Training and Credentials</Link>,
                // },

            ],

        },


    ];


    const items: MenuProps['items'] = [
        {
            label: <div onClick={() => { ((screens.sm && !screens.md) || screens.xs) && SetCollapsed(true); navigate("/user-profile") }}>Profile</div>,
            key: "Profile",
        },
        {
            label: <div onClick={() => showModal()}>Log Out</div>,
            key: "Logout",
        },
    ];

    // const sidebarWidth = screens.xxl ? "15%" : screens.xl ? "20%" : screens.lg ? "25%" : screens.md ? '30%' : screens.sm ? "30%" : screens.xs ? "100%" : "100%"
    const sidebarWidth = screens.xxl ? "17%" : screens.xl ? "20%" : screens.lg ? "25%" : screens.md ? '30%' : (screens.sm || screens.xs) ? "100%" : "100%"
    return (
        <>
            <Layout.Sider
                breakpoint="xl"
                onBreakpoint={(broken) => {
                    setIsMobile(broken);
                }}
                // trigger={screens.xs ? null : '>'}
                width={sidebarWidth}
                // width={"20rem"}
                collapsedWidth={((screens.sm && !screens.md) || screens.xs) ? "0" : "80"}
                theme="light"
                // collapsible={window.innerWidth > 1200 ? true : false}
                collapsible={true}
                collapsed={collapsed}
                onCollapse={(value) => SetCollapsed(value)}
                style={siderStyle}

                zeroWidthTriggerStyle={{ display: 'none' }}
            // {...{collapsedWidth:'0'}}
            >
                {!((screens.sm && !screens.md) || screens.xs) && <div className="headerWrap logo-left-head">
                    <div className="app_header_left">
                        <div className="logoImg" onClick={() => navigate("/dashboard")}>
                            <img className="icon" src={WebConstant?.IMAGE_URL + logo} alt="logo" />
                        </div>
                    </div>

                </div>}
                <Menu
                    selectedKeys={[location.pathname]}
                    mode="inline"
                    expandIcon={({ isOpen }) => <ProfileArrowIcon style={{ transition: 'rotate .3s', rotate: isOpen ? '90deg' : '0deg' }} />}
                    items={items2}
                    onClick={() => ((screens.sm && !screens.md) || screens.xs) && SetCollapsed(true)}
                />
                <div className="sidebar-btm-part">
                        <DashboardTranslateButtons />

                    <Space.Compact direction="vertical" style={{ width: '100%' }}>

                        <Dropdown menu={{ items }} >
                            <div>
                                <div className="profile-title-main">
                                    <SVGIcon icon="ProfileUserIcon" />
                                    <h1 className="profile-title">
                                        <div className="notranslate">{(userDetail?.name && userDetail?.name) + " " + (userDetail?.last_name && userDetail?.last_name)}</div>
                                        <span className="has-access">Starter Access</span>
                                    </h1>

                                </div>
                                <div className="profile-arrow-icon">
                                    <SVGIcon icon="ProfileArrowIcon" />
                                </div>
                            </div>
                        </Dropdown>
                    </Space.Compact>
                </div>
            </Layout.Sider>

            <CommonModal
                title={"Log Out?"}
                open={logOutModal}
                onCancel={closeModal}
                // className="logOutModal"
                footer={
                    <Row gutter={[15, 15]}>
                        <Col xs={24} sm={12} md={12} lg={12}>
                            <Button key="2" htmlType="button" className="common_button green_border_common_btn" onClick={closeModal}>
                                Cancel
                            </Button>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={12}>
                            <Button
                                key="1"
                                htmlType="button"
                                className=' common_button green_border_common_btn common_fill_button'
                                onClick={() => logOut()}

                            >
                                Confirm
                            </Button>
                        </Col>
                    </Row>
                }
            >
                <Flex align={'center'} vertical>
                    <p style={{marginBottom:'auto'}}>Are you sure you want to Log Out?</p>
                    <b>
                        <div className="notranslate">&ldquo;{(userDetail?.name && userDetail?.name) + " " + (userDetail?.last_name && userDetail?.last_name)}&rdquo;</div>
                    </b>

                </Flex>
            </CommonModal>
        </>



    );
}

export default SidebarView;
